/**
 * Block / Unblock API client — Phase 27.8.
 */
import api from './client';

export const blockUser = async (username) => {
  const res = await api.post(`/users/${encodeURIComponent(username)}/block`);
  return res.data;
};

export const unblockUser = async (username) => {
  const res = await api.post(`/users/${encodeURIComponent(username)}/unblock`);
  return res.data;
};

export const listBlocked = async () => {
  const res = await api.get('/users/me/blocked');
  return res.data;
};

export const getBlockStatus = async (username) => {
  const res = await api.get(`/users/${encodeURIComponent(username)}/block-status`);
  return res.data;
};
